import type { AnyRouter } from "@tanstack/react-router";

export const routerRef: { current: AnyRouter | null } = { current: null };
